import { AfterViewInit, Directive, ElementRef, Input, NgZone, OnDestroy } from "@angular/core";
import { fromEvent, map, Subject, switchMap, takeUntil } from "rxjs";

@Directive({
  selector: '[floatDialog]'
})
export class FloatDialog implements AfterViewInit, OnDestroy {

  @Input() handle: string;
  @Input() target: string;
  @Input() disabled: boolean = false;

  // Element to be dragged
  private targetEl: HTMLElement;
  // Drag handle
  private handleEl: HTMLElement;
  private delta = { x: 0, y: 0 };
  private offset = { x: 0, y: 0 };
  private top: any = 0;
  private handleHeight = 0;

  private destroy = new Subject<void>();

  constructor(private elementRef: ElementRef, private zone: NgZone) {
  }

  public ngAfterViewInit(): void {
    this.handleEl = this.handle ? document.querySelector(this.handle) as HTMLElement :
      this.elementRef.nativeElement;
    this.targetEl = document.querySelector(this.target) as HTMLElement;
    this.setupEvents();
    this.top = -parseInt(getComputedStyle(this.targetEl).getPropertyValue('top').replace("px", ""))
    this.handleHeight = parseInt(getComputedStyle(this.handleEl).getPropertyValue('height').replace("px", "")) * 2
  }

  public ngOnDestroy(): void {
    this.destroy.next();
  }

  private setupEvents() {
    this.zone.runOutsideAngular(() => {
      const mousedown = fromEvent<MouseEvent>(this.handleEl, 'mousedown');
      const mousemove = fromEvent<MouseEvent>(document, 'mousemove');
      const mouseup = fromEvent<MouseEvent>(document, 'mouseup');

      const mousedrag = mousedown.pipe(takeUntil(this.destroy))
        .pipe(switchMap((event: MouseEvent) => {
          const startX = event.clientX;
          const startY = event.clientY;

          return mousemove.pipe(takeUntil(mouseup))
            .pipe(map((event: MouseEvent) => {
              if(this.disabled)
                return
              event.preventDefault();
              let y = event.clientY - startY
              let yf = this.offset.y + y
              if (yf - this.top < 0)
                yf = this.top;
              else if (yf + this.handleHeight > window.innerHeight)
                yf = window.innerHeight - this.handleHeight

              y = yf - this.offset.y
              this.delta = {
                x: event.clientX - startX,
                y: y
              };
            })
            );
        })
        );

      mousedrag.pipe(takeUntil(this.destroy)).subscribe(() => {
        if (this.delta.x === 0 && this.delta.y === 0) {
          return;
        }

        this.translate();
      });

      mouseup.pipe(takeUntil(this.destroy)).subscribe(() => {
        this.offset.x += this.delta.x;
        this.offset.y += this.delta.y;
        this.delta = { x: 0, y: 0 };
      });
    });
  }

  private translate() {
    requestAnimationFrame(() => {
      this.targetEl.style.transform = `
        translate(${this.offset.x + this.delta.x}px,
                  ${this.offset.y + this.delta.y}px)
      `;
    });
  }
}